/**
 * Live countdown for the drop-countdown section.
 * Expects child elements with [data-unit="days|hours|minutes|seconds"].
 */

class DropCountdownTimer extends HTMLElement {
  /** @type {ReturnType<typeof setInterval> | undefined} */
  #timer;

  connectedCallback() {
    const endRaw = this.dataset.end;
    if (!endRaw) return;

    const endTime = Date.parse(endRaw);
    if (Number.isNaN(endTime)) return;

    const tick = () => {
      const now = Date.now();
      let diff = Math.max(0, endTime - now);

      const secs = Math.floor(diff / 1000);
      const days = Math.floor(secs / 86400);
      diff = secs % 86400;
      const hours = Math.floor(diff / 3600);
      diff = diff % 3600;
      const minutes = Math.floor(diff / 60);
      const seconds = diff % 60;

      const pad = (n) => String(n).padStart(2, '0');

      const d = this.querySelector('[data-unit="days"]');
      const h = this.querySelector('[data-unit="hours"]');
      const m = this.querySelector('[data-unit="minutes"]');
      const s = this.querySelector('[data-unit="seconds"]');
      if (d) d.textContent = pad(days);
      if (h) h.textContent = pad(hours);
      if (m) m.textContent = pad(minutes);
      if (s) s.textContent = pad(seconds);

      if (endTime <= now && this.#timer) {
        clearInterval(this.#timer);
        this.#timer = undefined;
      }
    };

    tick();
    this.#timer = setInterval(tick, 1000);
  }

  disconnectedCallback() {
    if (this.#timer) clearInterval(this.#timer);
  }
}

if (!customElements.get('drop-countdown-timer')) {
  customElements.define('drop-countdown-timer', DropCountdownTimer);
}
